import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  width: ${() => `${viewSizeCalculator(4)}`};
  height: ${() => `${viewSizeCalculator(4)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  background-color: #ffffff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  cursor: pointer;

  &:hover {
    background-color: #f6f6f6;
    box-shadow: 0px 1px 5px 0px #3333331a;
    border: ${() => `${viewSizeCalculator(2, true)} solid #3333331A`};
  }

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const Popup = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(2)}`};

  position: absolute;
  top: ${() => `${viewSizeCalculator(5.8)}`};
  left: ${() => `${viewSizeCalculator(1.25)}`};
  padding: ${() => `${viewSizeCalculator(1)}`};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  z-index: 100;
  color: #333333;
  height: 87vh;
  width: ${({ isAdvancedFilterVisible }) =>
    isAdvancedFilterVisible ? "80vw" : "24vw"};
  transform-origin: left;
  /* Initial state when hidden */
  transform: scaleX(0);
  opacity: 0;
  visibility: hidden;

  /* Apply transition */
  transition:
    width 0.7s ease,
    transform 0.7s ease 0.2s,
    opacity 0.3s ease 0.2s,
    visibility 0s linear 0.5s;

  /* When visible */
  ${({ isPopupVisible }) =>
    isPopupVisible
      ? `
      transform: scaleX(1);
      opacity: 1;
      visibility: visible;
      
    `
      : `
      transform: scaleX(0);
      opacity: 1;
      visibility: hidden;
    `}
`;

export const QuickFiltersContainer = styled.div`
  width: 24vw;
`;

export const AdvanceFilterContainer = styled.div`
  width: 80vw;
  overflow: hidden;
  padding-right: 8px; /* Prevents content from touching scrollbar */
`;
export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #333333;
  opacity: 0; /* Initially visible */
  z-index: 100; /* Behind the popup but above everything else */
  visibility: hidden;

  transition: opacity 0.3s ease-in-out, visibility 0s linear 0.3s;

  ${({ isPopupVisible }) =>
    isPopupVisible
      ? `
        opacity: 0.2;
        visibility: visible;
        transition: opacity 0.3s ease-in-out, visibility 0s linear 0s;
      `
      : `
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease-in-out, visibility 0s linear 0.3s;
      `}
`;

export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: ${() => `${viewSizeCalculator(1, true)} solid #ebebeb`};

  padding: ${() => `0 0 ${viewSizeCalculator(0.75)} 0`}; // 0 0 1.25rem 0;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  width: ${() => `${viewSizeCalculator(20.5)}`}; // 20.5rem

  svg path {
    color: #666;
    transition: fill 0.3s ease;
  }

  svg:hover path {
    fill: #000;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
`;

export const Reset = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  opacity: ${({ isDisabled }) => (isDisabled ? "30%" : "100%")};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isDisabled }) => !isDisabled && "#007bff"};
`;

export const FilterBodyContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${() => `${viewSizeCalculator(1)}`}; // 1.25rem

  margin-top: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
`;

export const FilterTitle = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 400;

  color: #333;
`;

export const Partition = styled.div`
  border-top: ${() => `${viewSizeCalculator(1, true)} solid #ebebeb`};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`};
`;

export const CheckboxLabel = styled.label`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 400;

  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? "30%" : "1")};
`;

export const AdvancedSearch = styled.div`
  padding: 8px 12px;
  width: fit-content;

  border-radius: 10px;

  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  color: #007bff;

  text-align: right;

  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const FilterFooterContainer = styled.div`
  position: absolute;
  bottom: ${() => `${viewSizeCalculator(1.5)}`};
  left: 0;
  right: 0;
  width: 92%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${() =>
    `${viewSizeCalculator(1.25)} ${viewSizeCalculator(
      1.5,
    )} 0 ${viewSizeCalculator(1.5)}`}; // 1.25rem 1.5rem 0 1.5rem
  /* margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 1.25rem */
`;

export const StyledButton = styled.button`
  border: ${() => `${viewSizeCalculator(1, true)} solid #333333`};
  outline: none;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem

  height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  width: ${() => `${viewSizeCalculator(9.375)}`}; // 9.375rem

  padding: ${() =>
    `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`}; // 0.5rem 0.75

  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  color: ${({ bgColor }) => (bgColor === "#333333" ? "#ffffff" : "#333333")};

  background-color: ${({ bgColor }) => bgColor || "#ffffff"};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  opacity: ${({ disabled }) => (disabled ? "30%" : "1")};

  &:hover {
    background-color: ${({ bgColor }) =>
      bgColor === "#A9A9A9" ? "#A9A9A9" : "#333333"};
    color: #ffffff;
    background-color: ${({ isCancel }) => isCancel && "#D9D9D966"};
    color: ${({ isCancel }) => isCancel && "#333"};
  }

  display: flex;
  align-items: center;
  justify-content: center;
`;
